import { numberToMoney } from "../../../lib/formatter";

/**
 * Tipos de pago del issuer_payment_type
 */
export const PAYMENT_TYPES = [
  { id: 1, nameKey: "paymentsHistory.paymentType_1" },
  { id: 2, nameKey: "paymentsHistory.paymentType_2" },
  { id: 3, nameKey: "paymentsHistory.paymentType_3" },
  { id: 4, nameKey: "paymentsHistory.paymentType_4" },
  { id: 5, nameKey: "paymentsHistory.paymentType_5" },
  { id: 6, nameKey: "paymentsHistory.paymentType_6" },
  { id: 7, nameKey: "paymentsHistory.paymentType_7" }
];

export const PAYMENT_TYPE_TAG_BLUE_IDS = [1, 2, 3, 4];
export const PAYMENT_TYPE_TAG_RED_IDS = [5, 6, 7];

/**
 * Color del tag según tipo de pago
 */
export const getPaymentTypeTagColor = (typeId) =>
  PAYMENT_TYPE_TAG_RED_IDS.includes(typeId) ? "#FF317B" : "#0BBEF0";

/**
 * IDs de tipo de pago visibles en el filtro del dropdown
 */
export const FILTER_PAYMENT_TYPE_IDS = [3, 5, 6];

/**
 * Opciones para dropdown de tipo de pago
 */
export const getPaymentTypeOptions = (t) =>
  PAYMENT_TYPES.filter(({ id }) => FILTER_PAYMENT_TYPE_IDS.includes(id)).map(
    ({ id, nameKey }) => ({
      id,
      value: String(id),
      text: t(nameKey)
    })
  );

/**
 * Determina si un tipo de pago es de mora
 */
export const isOverdueType = (typeId) =>
  PAYMENT_TYPE_TAG_RED_IDS.includes(typeId);

/**
 * Campos de detalle para cuotas ordinarias (tipos 1,2,3,4)
 */
export const DETAIL_FIELDS_ORDINARY = [
  "plus_capital",
  "plus_interest",
  "less_retentions",
  "fng_commission",
  "bvc_commission"
];

/**
 * Campos de detalle para mora (tipos 5,6,7)
 */
export const DETAIL_FIELDS_OVERDUE = [
  "plus_capital",
  "plus_interest",
  "plus_overdue_interest",
  "less_retentions",
  "less_overdue_retentions",
  "fng_commission",
  "bvc_commission",
  "collection_commission"
];

/**
 * Retorna los campos visibles según tipo de pago
 */
export const getVisibleDetailFields = (typeId) =>
  isOverdueType(typeId) ? DETAIL_FIELDS_OVERDUE : DETAIL_FIELDS_ORDINARY;

/**
 * Campos de comisiones que llevan *IVA
 */
export const COMMISSION_FIELDS = [
  "fng_commission",
  "bvc_commission",
  "collection_commission"
];

/**
 * Campos que se muestran en rojo (retenciones)
 */
export const NEGATIVE_FIELDS = ["less_retentions", "less_overdue_retentions"];

/**
 * Formatea un monto de pago a formato COP con 2 decimales
 */
export const formatPaymentAmount = (amount) => {
  const value = parseFloat(amount) || 0;
  return numberToMoney(Math.abs(value), "COP $", ".", ",", ".", true, true);
};

/**
 * Formatea un monto sin prefijo COP $
 */
export const formatPaymentValue = (amount) => {
  const value = parseFloat(amount) || 0;
  return numberToMoney(Math.abs(value), "", ".", ",", ".", true, true);
};

/**
 * Estados de pago para filtros (legacy)
 */
export const PAYMENT_HISTORY_STATES = [
  { value: "pending_approve", key: "paymentsHistory.pending_approve" },
  { value: "approved", key: "paymentsHistory.approved" },
  { value: "rejected", key: "paymentsHistory.rejected" },
  { value: "paid", key: "paymentsHistory.paid" },
  { value: "inactive", key: "paymentsHistory.inactive" }
];

export const getPaymentStateOptions = (t) =>
  PAYMENT_HISTORY_STATES.map(({ value, key }) => ({
    value,
    text: t(key)
  }));
